import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type CurrentAdminService from 'garaje/services/current-admin';
import { GLOBAL_ADMIN } from 'garaje/utils/roles';
import _intersection from 'lodash/intersection';

const ALLOWED_ROLES = [GLOBAL_ADMIN];

export default class MacAddressMappingAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;

  get canView(): boolean {
    return isPresent(_intersection(ALLOWED_ROLES, this.currentAdmin.roleNames));
  }

  get canManage(): boolean {
    return isPresent(_intersection(ALLOWED_ROLES, this.currentAdmin.roleNames));
  }
}
